// Display call to action on click
const prompts = document.querySelectorAll('.js-click-prompt');

function init() {
  prompts.forEach(prompt => {
    prompt.addEventListener('click', () => {
      prompt.classList.toggle('active');
    });
  });
}

// Remove active state on safari if safari has cached the page and user has clicked the back button
window.onpageshow = event => {
  if (event.persisted) {
    prompts.forEach(prompt => {
      prompt.classList.remove('active');
    });
  }
};

(() => {
  init();
})();
